// extracted by mini-css-extract-plugin
export default {"productCarousel":"u0-z"};